export default __webpack_public_path__ + "static/SRUS LF735 - Product Specifications & Technical Data-a642ce7fad2dc198a54b6322d08619af.pdf";